
















































import { defineComponent, computed, ref, inject } from "@vue/composition-api";
import DraggableWindow from "./DraggableWindow.vue";
import ElementEditor from "./ElementEditor.vue";
import { useTogglable } from "@/compositions/useTogglable";
import { useState } from "@/compositions/useNodeState";
import { fold } from "fp-ts/lib/Option";
import { pipe } from "fp-ts/es6/pipeable";
import { Node, NodeTree } from "@/types";
import { NodeDaoInjectionKey } from "@/domain/nodes";
import { AliasDaoInjectionKey } from "@/domain/alias";

interface TreeView {
  id: string;
  name: string;
  children: TreeView[];
}
const toTree = (node: NodeTree): TreeView => {
  return {
    id: node.value.id,
    name: node.value.name || node.value.tag,
    children: node.forest.map(toTree)
  };
};
export default defineComponent({
  components: {
    ElementEditor,
    DraggableWindow,
    AliasRegister: () => import("./AliasRegister.vue")
  },
  setup() {
    const nodeDao = inject(NodeDaoInjectionKey);
    const aliasDao = inject(AliasDaoInjectionKey);
    if (!nodeDao || !aliasDao) {
      throw new Error("Dao is not injected");
    }
    const { on, off, isActive: editorIsActive } = useTogglable();
    const {
      node,
      removeNodeById,
      findById,
      editNode: editNodeById,
      copyNode
    } = useState(nodeDao, aliasDao);
    const editNode = ref<Node>({
      id: "",
      tag: "div"
    });
    const setEditTarget = (n?: Node) =>
      pipe(
        findById(n ? n.id : ""),
        fold(off, (node: NodeTree) => {
          editNode.value = node.value;
          return on();
        })
      );
    const treeNode = computed(() => toTree(node.value));
    const { toggle, isActive } = useTogglable();
    return {
      treeNode,
      toggle,
      isActive,
      removeNodeById,
      show: on,
      hide: off,
      editorIsActive,
      editNode,
      findById,
      editNodeById,
      setEditTarget,
      copyNode
    };
  }
});
